import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import { MasterSessionKey } from '@src/store/types'

import { SortOrder } from '@store/constants'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

interface AccessUser {
  id: string
  email: string
}

export interface BaseMasterKey {
  access: AccessUser[]
  id: string
  label: string
  masterKey: string
  sessionKeys: MasterSessionKey[]
}

export interface MasterKeyData extends BaseMasterKey {
  children?: BaseMasterKey[]
  isParent: true
}

interface MasterKeyParams {
  masterKey: string
  userId: string
  sort_order?: SortOrder
  sort_field?: 'created_at' | 'updated_at'
  accessToken?: string
}

export const masterKeyApi = createApi({
  reducerPath: 'masterKeyApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getMasterKey: builder.query<ApiResponse<MasterKeyData>, MasterKeyParams>({
      query: ({
        masterKey,
        userId,
        sort_order,
        sort_field,
        accessToken,
      }: MasterKeyParams) => ({
        url: `/v2/master-keys/${masterKey}/${userId}`,
        method: 'GET',
        params: {
          ...(sort_order && { sort_order }),
          ...(sort_field && { sort_field }),
        },
        headers: {
          ...(accessToken && {
            Authorization: `Bearer ${accessToken}`,
          }),
        },
      }),
    }),
  }),
})

export const selectFromResult = ({
  data,
  isLoading,
  isError,
  status,
}: UseQueryStateResult<any, any>): {
  masterKeyData: MasterKeyData
  isLoaded: boolean
  isError: boolean
  status: string
} => ({
  masterKeyData: data?.data || {},
  isLoaded: !isLoading,
  isError,
  status,
})

export const { useGetMasterKeyQuery, useLazyGetMasterKeyQuery } = masterKeyApi
